
// sample data = [12, 19, 3, 5, 2, 3]  179, 245, 93
// label = ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange', 'lightgreen']
// backgroundColor= ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 
// 'rgba(255, 206, 86, 0.2)' , 'rgba(179, 245, 93, 0.2)', 'rgba(255, 159, 64, 0.2)', 'rgba(75, 192, 192,0.2)']
// bordercolor= ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 
// 'rgba(255, 206, 86, 0.2)' , 'rgba(75, 192, 192, 0.2)', 'rgba(255, 159, 64, 0.2)']




import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
// import {overallscore} from "../SampleData/AnalysisWindowConst"
import { overallscore } from '../../layout/SampleData/AnalysisWindowConst';
import {bgColors} from "../../../components/utils/bgColor"
import {color_map_score} from './colorconst'
ChartJS.register(ArcElement, Tooltip, Legend)


const yield_score = (overallscore.yield_score/5)*100
const irrigation = (overallscore.irrigation/5)*100
const perf_data = [yield_score, (100-yield_score)]
const irrigation_date = [irrigation, (100-irrigation)]

const borderColor_perf = [ color_map_score(overallscore.yield_score), 'rgba(255, 255, 255, 0.2)']
const borderColor_irrigation = [ color_map_score(overallscore.irrigation), 'rgba(255, 255, 255, 0.2)']

export const options_perf = {

  responsive: true,
  // innerHeight:'10px',
  maintainAspectRatio: false,
  plugins: {
    legend: {
       display: false
    },
    title: {
      display: true,
      text: 'Performance score'
  }
  },
};


export const options_irrigation = {
  responsive: true,
  // innerHeight:'10px',
  maintainAspectRatio: false,
  plugins: {
    legend: {
       display: false
    },
    title: {
      display: true,
      text: 'Irrigation score'
  }
  },
};



export function irrigationDataDonut(irrigationtable){
  let sum = 0
  let count = 0
  let weighted_score
  let borderColor_irrigation
  let donust_score
  let irrigation_date 
  let irrigation_data_donut
  let score_bin = 5
  let score_bin_size= 20
  for (let i = 0; i < irrigationtable.length; i++){
    // console.log(parseFloat(irrigationtable[i].season_weight))
      if( irrigationtable[i].moisturescore !==undefined && irrigationtable[i].moisturescore!=null
          
          )
      {sum += irrigationtable[i].moisturescore*parseFloat(irrigationtable[i].season_weight)
        count+=parseFloat(irrigationtable[i].season_weight)
      }
      weighted_score = sum/count
  }
  donust_score =  (weighted_score/score_bin)*100
  // console.log(donust_score)
  irrigation_date = [donust_score/score_bin_size, (100-donust_score)/score_bin_size]
  borderColor_irrigation = [ color_map_score(weighted_score), 'rgba(255, 255, 255, 0.2)']
  // console.log(irrigationtable)
  irrigation_data_donut = {
    labels: ['irrigation'],
    datasets: [
      {
        data: irrigation_date,
        backgroundColor:borderColor_irrigation,
        borderColor: borderColor_irrigation,
        borderWidth: 1,
      },
    
    ],
    text: '23%'
  };

  return irrigation_data_donut

}


export function perfDataDonut(perftable){
  let sum = 0
  let count = 0
  let weighted_score
  let borderColor_perf
  let donust_score
  let perf_data 
  let perf_data_donut
  let score_bin = 5
  let score_bin_size= 20
  for (let i = 0; i < perftable.length; i++){
      if( perftable[i].perfscore !==undefined && perftable[i].perfscore!=null
          
          )
      {sum += perftable[i].perfscore*parseFloat(perftable[i].season_weight)
        count+=parseFloat(perftable[i].season_weight)
      }
      weighted_score = sum/count
  }
  donust_score =  (weighted_score/score_bin)*100
  perf_data = [donust_score/score_bin_size, (100-donust_score)/score_bin_size]

  borderColor_perf = [ color_map_score(weighted_score), 'rgba(255, 255, 255, 0.2)']
  perf_data_donut = {

    labels: ['performance'],
    datasets: [
      {
        data: perf_data,
        backgroundColor:borderColor_perf,
        borderColor: borderColor_perf,
        borderWidth: 1,
      },
    ],
    text: '23%'
  };

  return perf_data_donut

}

export const perf_data_donut = {

  labels: ['performance'],
  datasets: [
    {
      data: perf_data,
      backgroundColor:borderColor_perf,
      borderColor: bgColors.grey_200,
      borderWidth: 1,
    },
  ],
  text: '23%'
};

export const irrigation_data_donut = {
  labels: ['irrigation'],
  datasets: [
    {
      data: irrigation_date,
      backgroundColor:borderColor_irrigation,
      borderColor: borderColor_irrigation,
      borderWidth: 1,
    },
  ],
  text: '23%'
};



export function PerfDonut(props) {
  const {data} = props
  return <Doughnut options={options_perf} data={data} />;
}

export function IrrigationDonut(props) {
  const {data} = props
  return <Doughnut options={options_irrigation} data={data} />;
}












